export default __webpack_public_path__ + "ed02eec0bcc52c3758cd80fcd614642d.png";